import { useEffect, useRef } from 'react'

export const PopupContentPark = ({ data, unit, color, isOverviewDAH }) => {
  const ref = useRef()

  // Fallback handling
  const backgroundColor = color === 'transparent' ? '#FFFFFF' : color
  const textColor = '#000' // always black for legibility on red/green/white

  useEffect(() => {
    if (!isOverviewDAH || !ref.current) return

    const popupRoot = ref.current.closest('.leaflet-popup')
    const wrapper = popupRoot?.querySelector('.leaflet-popup-content-wrapper')
    const tip = popupRoot?.querySelector('.leaflet-popup-tip')
    const closeBtn = popupRoot?.querySelector('.leaflet-popup-close-button')

    if (wrapper) {
      wrapper.style.setProperty(
        'background-color',
        backgroundColor,
        'important',
      )
      wrapper.style.setProperty('color', textColor, 'important')
    }

    if (tip) {
      tip.style.setProperty('background-color', backgroundColor, 'important')
    }

    if (closeBtn) {
      closeBtn.style.setProperty('color', textColor, 'important')
      // Optional enhancements:
      closeBtn.style.setProperty('font-weight', 'bold')
      closeBtn.style.setProperty('font-size', '20px')
    }
  }, [backgroundColor, textColor, isOverviewDAH])

  return (
    <div ref={ref} style={{ fontWeight: 'bold', minWidth: 180 }}>
      <b>Name:</b> {data.name}
      <br />
      <b>Installed Capacity:</b> {data.installedCapacity} {unit}
      <br />
      <b>Technology:</b> {data.technology}
      <br />
      {data.dahError !== undefined && data.dahError !== null && (
        <>
          <b>DAH Error:</b> {data.dahError}
          <br />
        </>
      )}
    </div>
  )
}
